import React from 'react'
import MixBarChartPanel from '../../../components/Charts/MixBarChartPanel';
import FilterPanel from '../components/FilterPanel';

const WinLoseReportByDate = () => {
  return (
    <div className='p-2'>
         <div className='flex justify-between border-b border-b-gray-300 pb-2 mb-1'>
            <h1 className="font-semibold">Win Lose Report By Date</h1>
            <FilterPanel/>
        </div>
        <div className="w-full h-[250px]">
              <MixBarChartPanel _data={data}/>
        </div>
    </div>
  )
}

export default WinLoseReportByDate;

const data = [
  {
    "date" : "2024-01-01",
    "single" : 40,
    "mix" : 30,
    "win" : 20
  },
  {
    "date" : "2024-01-02",
    "single" : 50,
    "mix" : 10,
    "win" : 20
  },
  {
    "date" : "2024-01-03",
    "single" : 60,
    "mix" : 20,
    "win" : 20
  },
  {
    "date" : "2024-01-04",
    "single" : 40,
    "mix" : 15,
    "win" : 20
  },
  {
    "date" : "2024-01-05",
    "single" : 40,
    "mix" : 25,
    "win" : 20
  },
  {
    "date" : "2024-01-06",
    "single" : 40,
    "mix" : 26,
    "win" : 20
  },
  {
    "date" : "2024-01-07",
    "single" : 70,
    "mix" : 20,
    "win" : 20
  }
]